import {
  DiscountApplicationOrderDto,
  DiscountDto,
  DiscountTypeDto,
  PriceDto,
  PriceTypeDto
} from '@eurogast/hub-client-typescript';

export abstract class PriceDeserializer {
  public static parsePrice(price: string): PriceDto {
    const parts = price.split('::');
    if (parts.length !== 7) {
      throw Error(`Invalid price format: ${price}`);
    }
    return {
      sku: parts[0],
      toDate: parts[1],
      minQuantity: Number.parseFloat(parts[2]),
      price: Number.parseFloat(parts[3]),
      rawValueString: parts[3],
      type: PriceTypeDto[parts[4].replace('_', '')],
      attachedDiscount: PriceDeserializer.parseDiscount(parts[5]),
      uvp: Number.parseFloat(parts[6])
    };
  }

  public static parseDiscount?(source: string): DiscountDto {
    if (!source) {
      return null;
    }
    const parts = source.split(';:;');
    if (parts.length !== 3) {
      throw Error(`Invalid discount format ${source}`);
    }
    return {
      type: DiscountTypeDto[parts[0]],
      applicationOrder: DiscountApplicationOrderDto[parts[1]],
      discountFactor: Number(parts[2]),
      discountFactorString: parts[2]
    };
  }

  public static parsePriceList(source: string): PriceDto[] {
    return source.split('};{').map((s) => {
      let startPos = 0;
      let endPos = s.length;
      if (s.startsWith('[{')) {
        startPos = 2;
      }
      if (s.endsWith('}]')) {
        endPos -= 2;
      }
      return this.parsePrice(s.substring(startPos, endPos));
    });
  }
}
